import { render, staticRenderFns } from "./RaceCard.vue?vue&type=template&id=65c3c92a&scoped=true"
import script from "./RaceCard.vue?vue&type=script&lang=js"
export * from "./RaceCard.vue?vue&type=script&lang=js"
import style0 from "./RaceCard.vue?vue&type=style&index=0&id=65c3c92a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c3c92a",
  null
  
)

export default component.exports